export const NAME = 'subdepartments';